import { useContext } from "react";

import { SignupsAppState } from "Signups/state.js";

export function useGetCurrentSignupList() {
  const [state] = useContext(SignupsAppState);
  return state.currentSignupList ? state.currentSignupList : {};
}
